export default [
  {
    position: "absolute",
    top: 39.7,
    left: 50.2,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-middle-left",
    isDialog: true,
    modal: false,
    mTitle: "hiringMoreP2.mTitleOne",
    mBody: "hiringMoreP2.mBodyOne",
    id: "SP_MyVacancies_Info_MakeHiringSimple",
    infoIcon: true,
    isAction: false,
    index: 0
  },
  {
    position: "absolute",
    top: 19.5,
    left: 37,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "hiringP2.mTitleOne",
    mBody: "hiringP2.mBodyOne",
    id: "SP_Hiring_Info_InternalVacancies",
    infoIcon: true,
    isAction: false,
    index: 1
  },
  {
    position: "absolute",
    top: 0.6,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "hiringMoreP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_MyVacancies_Navigation_Menu",
    index: 2
  },
  {
    position: "absolute",
    top: 4.5,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "hiringMoreP2.ttTextTwo",
    hover: false,
    id: "SP_MyVacancies_Navigation_Communications",
    index: 3
  },
  {
    position: "absolute",
    top: 4.5,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "hiringMoreP2.ttTextThree",
    hover: false,
    id: "SP_MyVacancies_Navigation_PayBenefits",
    index: 4
  },
  {
    position: "absolute",
    top: 4.5,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "hiringMoreP2.ttTextFour",
    hover: false,
    id: "SP_MyVacancies_Navigation_Absence",
    index: 5
  },
  {
    position: "absolute",
    top: 4.5,
    left: 50.45,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "hiringMoreP2.ttTextFive",
    hover: false,
    id: "SP_MyVacancies_Navigation_Performance",
    index: 6
  },
  {
    position: "absolute",
    top: 4.5,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "hiringMoreP2.ttTextSeven",
    hover: false,
    id: "SP_MyVacancies_Navigation_Hiring",
    index: 7
  },
  {
    position: "absolute",
    top: 3.4,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "hiringMoreP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_MyVacancies_Navigation_TeamMember",
    index: 8
  },
];
